import * as angular from 'angular';
import * as _ from 'lodash';

import { IAuthenticationService, IApplicationService, IExportToCsvService } from '@services/index';
import { Roles } from '../../../common/constants';
import { Application, ComponentDefinition, ApplicationDto } from '@models/index';

class ApplicationsManagementController implements angular.IComponentController {
    static controllerId: string = 'ApplicationsManagement';

    isLoading: boolean;
    canImport: boolean;
    allApplications: Application[];
    applications: ApplicationDto[];

    static $inject = ['authenticationService', 'applicationService', 'exportToCsvService'];

    constructor(private authenticationService: IAuthenticationService,
        private _applicationService: IApplicationService,
        private _exportToCsvService: IExportToCsvService) {
    }

    $onInit() {
        this.canImport = this.authenticationService.authentication.isSuperAdmin ||
            _.intersection(this.authenticationService.authentication.roles, Roles.applicationVisibilityRoles).length > 0;
        this._applicationService.getAll(data => this.allApplications = data.map(d => d.application));
    }

    exportToCsv() {
        const dataTable: any[][] = [];
        this.applications.forEach(application => {
            const row: any[] = [];
            row.push(application.application.name);
            row.push(application.administratorNames);
            row.push(application.application.identifiersCount);
            row.push(application.application.creationDate);
            row.push(application.application.creationUser);
            dataTable.push(row);
        });
        this._exportToCsvService.getCsvFromData(dataTable, 'applications.csv');
    }

}

export const wtApplicationsManagement: ComponentDefinition = {
    componentId: 'wtApplicationsManagement',
    controller: ApplicationsManagementController,
    template: require('./applicationsManagement.component.html'),
    controllerAs: 'vm'
};
